import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { get } from 'scriptjs';
import { LiveService } from '../../services/live.service';
import { interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Utils } from '../../services/util.service';

declare var registerIVSTech: any;
declare var videojs: any;

@Component({
    selector: 'ivs-live',
    templateUrl: './ivs-live.component.html',
    styleUrls: ['./ivs-live.component.css']
})
export class IvsLiveComponent implements OnInit, OnDestroy {
    player: any;
    error: boolean = false;

    currentWatchTime = 0;
    watchDuration: number = 0;
    sessionGuid: string;

    currentStatus: PlayerStatus = PlayerStatus.Unknown;

    @Input() url: string;
    @Input() livestreamId : number;

    destroy$ = new Subject<void>();

    constructor(private liveService: LiveService) {
    }

    ngOnInit(): void {
        get('https://player.live-video.net/1.3.1/amazon-ivs-videojs-tech.min.js', () => {
            registerIVSTech(videojs);

            this.player = videojs('ivsPlayer', {
                techOrder: ['AmazonIVS'],
                controlBar: {
                    pictureInPictureToggle: false
                }
            }, () => {
                this.player.src(this.url);
            });
            document.getElementsByClassName('vjs-subs-caps-button')[0].classList.add('disabled', 'd-none');

            interval(300000).pipe(takeUntil(this.destroy$)).subscribe(() => {
                if (this.currentStatus === PlayerStatus.Playing) {
                    this.reportWatchTime();
                }
            });

            let playerEvent = this.player.getIVSEvents().PlayerEventType;

            this.player.getIVSPlayer().addEventListener(playerEvent.ERROR, () => {
                console.log('ivs error');
                this.error = true;
            });

            // Event when stream pauses or ends
            this.player.getIVSPlayer().addEventListener(playerEvent.INITIALIZED, (e) => {
                this.sessionGuid = Utils.generateGUID();
                this.reportWatchTime(false);
            });

            // Event when stream pauses or ends
            this.player.getIVSPlayer().addEventListener(playerEvent.STATE_CHANGED, (e) => {
                this.currentStatus = e;
                if (this.currentStatus === PlayerStatus.Ended) {
                    this.reportWatchTime();
                }
            });

            // Optional: pause handling
            this.player.getIVSPlayer().addEventListener(playerEvent.TIME_UPDATE, (watchTime: number) => {
                if (watchTime === 0) {
                    this.watchDuration += this.currentWatchTime;
                }

                this.currentWatchTime = watchTime;
            });
        });
    }

    refresh() {
        this.error = false;
        this.player.src(this.url);
    }

    reportWatchTime(reportTime = true) {
        this.liveService.reportWatchtime(this.sessionGuid, this.livestreamId, reportTime ? Math.floor((this.watchDuration + this.currentWatchTime) * 1000) : undefined).subscribe();
    }

    ngOnDestroy() {
        this.player.dispose();
        this.destroy$.next();
        this.destroy$.complete();
        this.reportWatchTime();
    }

}

enum PlayerStatus {
    Unknown = 'Unknown',
    Playing = 'Playing',
    Paused = 'Paused',
    Ended = 'Ended'
}
